// Alt Yüklenici / Tarife Yönetimi sayfası ve tarife penceresi. Excel ve PDF Türkçe kalır.
const tariffs = {
  page: {
    title: 'Alt Yüklenici / Tarife Yönetimi',
    subtitle: 'Müşteri ve proje bazında FTE ve saat tarifeleri; tutarlar değer × birim fiyattan hesaplanır.',
  },
  yes: 'Evet',
  no: 'Hayır',
  types: {
    hour: 'Saat',
  },
  status: {
    active: 'Aktif',
    passive: 'Pasif',
  },
  common: {
    cancel: 'İptal',
  },
  actions: {
    withoutTariffs: 'Tarifesiz Projeler',
    withoutTariffsHint: 'Hiç tarife eklenmemiş projeleri göster',
    excel: 'Excel',
    excelHint: 'Görüntülenen listeyi Excel olarak indir',
    pdf: 'PDF',
    pdfHint: 'Görüntülenen listeyi PDF olarak indir',
    preparing: 'Hazırlanıyor…',
    add: 'Yeni Tarife',
  },
  stats: {
    total: 'Toplam Tarife',
    totalShort: 'Toplam',
    active: 'Aktif Tarife',
    activeShort: 'Aktif',
    inactive: 'Pasif Tarife',
    inactiveShort: 'Pasif',
    withoutTariffs: 'Tarifesiz Proje',
    withoutTariffsShort: 'Tarifesiz',
    share: 'Tüm tarifelerin %{{percent}}’i',
  },
  toolbar: {
    search: 'Müşteri, proje, tip, değer veya bilgi ara…',
    searchShort: 'Tarife ara…',
    project: 'Projeye göre filtrele',
    allProjects: 'Tüm projeler ({{count}})',
    clearProject: 'Proje filtresini temizle',
    testProjects: 'Test projeleri',
    testProjectsShow: 'Test projelerine ait tarifeleri listeye dahil et',
    testProjectsHide: 'Test projelerine ait tarifeleri listeden gizle',
    totals: 'Toplam tutar',
    totalsHint: 'Listelenen tarifelerin döviz bazında toplam tutarı',
  },
  table: {
    listLabel: 'Tarife listesi',
    empty: 'Filtrelere uygun tarife bulunamadı',
    rangeOf: '/ {{total}} tarife',
    ofTotal: 'toplam {{total}} tarife içinden',
    jump: 'Sayfaya git',
    deletedProject: 'Silinmiş proje',
    deletedProjectHint: 'Bu tarifenin bağlı olduğu proje silinmiş',
  },
  columns: {
    customer: 'Müşteri',
    project: 'Proje',
    type: 'Tarife Tipi',
    value: 'Tarife Değer',
    price: 'Birim Fiyat',
    amount: 'Tutar (Değer × Fiyat)',
    currency: 'Döviz Tipi',
    date: 'Tarih',
    subcontractor: 'Subcontractor',
    info: 'Bilgi',
    status: 'Durum',
  },
  panel: {
    label: 'Seçili tarife',
    heading: 'Tarife',
    tariff: 'Tarife',
    edit: 'Düzenle',
    delete: 'Sil',
    subcontractor: 'Subcontractor: {{answer}}',
  },
  delete: {
    title: 'Tarifeyi sil',
    message: '{{type}} {{value}} tarifesi ({{project}}) kalıcı olarak silinecek. Emin misiniz?',
    confirm: 'Sil',
  },
  withoutTariffs: {
    title: 'Hiç Tarife Eklenmemiş Projeler ({{count}})',
    subtitle: 'Bir projeye tarife eklemek için kartındaki düğmeye dokunun.',
    allDone: 'Tüm projelere en az bir tarife eklenmiş!',
    search: 'Proje veya müşteri ara…',
    noMatch: 'Aramaya uyan proje yok.',
    add: 'Tarife Ekle',
  },
  modal: {
    titleAdd: 'Yeni Tarifeler Ekle',
    subtitleAdd: 'Bir müşterinin bir veya birden çok projesi için tarife oluşturun',
    titleEdit: 'Tarife Düzenle',
    choose: 'Lütfen seçiniz',
    customer: 'Müşteri',
    customersLoading: 'Müşteriler yükleniyor…',
    projects: 'Projeler (çoklu seçim)',
    projectsLoading: 'Projeler yükleniyor…',
    chooseCustomerFirst: 'Önce müşteri seçiniz',
    noProjects: 'Bu müşteri için proje bulunamadı',
    hasTariffs: 'Tarife mevcut',
    projectsSelected_one: '{{count}} proje seçildi',
    projectsSelected_other: '{{count}} proje seçildi',
    currencyInfo: 'Seçili projelerin kur bilgisi',
    currencyFixed: 'Kur sabitlemesi var ({{rate}})',
    currencyNotFixed: 'Kur sabitlemesi yok',
    type: 'Tarife Tipi',
    currency: 'Döviz Tipi',
    date: 'Tarih',
    subcontractor: 'Subcontractor?',
    info: 'Bilgi',
    fteTitle: 'FTE Değerleri',
    hourlyTitle: 'Saat Ücreti',
    chooseTypeFirst: 'Değerleri girmek için önce tarife tipini seçin.',
    hourlyRate: '1 Saatlik Ücret',
    raise: 'Tarifelere Zam Yap (%)',
    raisePlaceholder: 'Örn: 10',
    raiseHintHourly: 'Mevcut saatlik ücrete belirtilen yüzde kadar artış uygulamak için "Uygula"ya dokunun.',
    raiseHintFte: 'Seçili FTE değerlerinin fiyatlarına belirtilen yüzde kadar artış uygular.',
    apply: 'Uygula',
    fteHintEdit: 'Mevcut bir FTE değerini kaldırmak için "Kaldır"a dokunabilirsiniz.',
    fteHintAdd: 'Eklemek istediğiniz FTE değerlerini seçin.',
    defaultPrice: 'Varsayılan Fiyat',
    defaultPricePlaceholder: 'Seçilen FTE değerleri için fiyat',
    defaultPriceHint: 'Seçilen tüm FTE değerlerine uygulanır, sonradan tek tek düzenlenebilir.',
    existing: 'Mevcut',
    selected: 'Seçildi',
    notSelected: 'Seçilmedi',
    price: 'Fiyat',
    priceFor: 'FTE {{value}} fiyatı',
    remove: 'Kaldır',
    removeHint: 'Bu değeri kaldır',
    fteClickHint: 'Seçmek veya kaldırmak için FTE değerlerine dokunabilirsiniz.',
    existingTitle: 'Seçili projelere ait mevcut tarifeler',
    existingLoading: 'Tarifeler yükleniyor…',
    recordValue: 'Değer: {{value}}',
    recordPrice: 'Fiyat: {{price}}',
    recordCurrency: 'Döviz: {{currency}}',
    recordDate: 'Tarih: {{date}}',
    noExistingForProject: 'Bu projeye ait mevcut tarife yok (eklenebilir)',
    noExisting: 'Seçili projelere ait mevcut tarife bulunamadı',
    save: 'Kaydet',
    update: 'Güncelle',
    saving: 'Kaydediliyor…',
  },
  toast: {
    projectsError: 'Projeler yüklenirken bir hata oluştu',
    loadError: 'Tarifeler yüklenirken bir hata oluştu',
    deleted: 'Tarife başarıyla silindi',
    deleteError: 'Tarife silinirken bir hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
    nothingToExport: 'Dışa aktarılacak tarife bulunmuyor.',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Excel dosyası oluşturulurken bir hata oluştu',
    pdfDone: 'PDF dosyası başarıyla indirildi',
    pdfError: 'PDF dosyası oluşturulurken bir hata oluştu',
    customersError: 'Müşteriler yüklenirken bir hata oluştu',
    existingError: 'Mevcut tarifeler yüklenirken bir hata oluştu.',
    required: 'Lütfen tüm zorunlu alanları doldurun',
    hourlyRequired: 'Lütfen saatlik ücreti girin',
    fteRequired: 'Lütfen en az bir FTE değeri seçin',
    updated: 'Tarife başarıyla güncellendi',
    updatedCount: '{{count}} tarife güncellendi',
    createdCount: '{{count}} yeni tarife eklendi',
    deactivatedCount: '{{count}} tarife pasif hale getirildi',
    skipped: 'Aşağıdaki projeler zaten tarifelere sahip olduğu için atlandı: {{projects}}',
    nothingToAdd: 'Eklenecek yeni tarife bulunamadı',
    saveError: 'Tarifeler işlenirken bir hata oluştu',
    percentRequired: 'Lütfen bir artış yüzdesi girin',
    noPricedSelection: 'Fiyatı girili seçili tarife bulunamadı',
    percentApplied: 'Seçili tarifelere %{{percent}} zam uygulandı',
    positivePercent: 'Lütfen pozitif bir artış yüzdesi girin',
    hourlyFirst: 'Önce saatlik ücret girmelisiniz',
    hourlyRaised: 'Saatlik ücret %{{percent}} oranında artırıldı',
  },
};

export default tariffs;
